/* L&S: Fortschrittsbalken und Endlosschleife für Produkt-Slider (wie im Vorbild). Ersetzt die Zählung „1 / 3“ optisch. */
(function () {
  function attach(sliderComponent) {
    if (sliderComponent.dataset.lsProgress) return;
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const buttons = sliderComponent.querySelector('.slider-buttons');
    if (!slider || !buttons) return;
    sliderComponent.dataset.lsProgress = 'true';

    const track = document.createElement('span');
    track.className = 'ls-slider-progress';
    track.setAttribute('aria-hidden', 'true');
    const fill = document.createElement('span');
    fill.className = 'ls-slider-progress__fill';
    track.appendChild(fill);
    buttons.prepend(track);

    const update = () => {
      const max = slider.scrollWidth - slider.clientWidth;
      const visible = slider.scrollWidth > 0 ? slider.clientWidth / slider.scrollWidth : 1;
      const progress = max > 0 ? slider.scrollLeft / max : 0;
      const width = Math.max(visible, 0.08) * 100;
      fill.style.width = `${width}%`;
      fill.style.transform = `translateX(${(progress * (100 - width) * 100) / width}%)`;
    };

    // Endlosschleife: Pfeile nie sperren; am Ende springt „weiter“ an den Anfang, am Anfang „zurück“ ans Ende
    const prev = buttons.querySelector('.slider-button--prev');
    const next = buttons.querySelector('.slider-button--next');
    const unlock = () => {
      [prev, next].forEach((button) => button && button.hasAttribute('disabled') && button.removeAttribute('disabled'));
    };
    const lockObserver = new MutationObserver(unlock);
    [prev, next].forEach((button) => button && lockObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] }));
    unlock();

    sliderComponent.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.slider-button');
        if (!button || !buttons.contains(button)) return;
        const max = slider.scrollWidth - slider.clientWidth;
        const atEnd = slider.scrollLeft >= max - 4;
        const atStart = slider.scrollLeft <= 4;
        if (button === next && atEnd) {
          event.preventDefault();
          event.stopImmediatePropagation();
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (button === prev && atStart) {
          event.preventDefault();
          event.stopImmediatePropagation();
          slider.scrollTo({ left: max, behavior: 'smooth' });
        }
      },
      true
    );

    slider.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    new ResizeObserver(update).observe(slider);
    update();
  }

  function init() {
    document.querySelectorAll('.collection slider-component').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
